import React from "react";
import './KeyFeaturesComponent.scss';
import { useTranslation } from "react-i18next";
import { keyFeaturesComponentProps } from "../../constants/interface";

const KeyFeaturesComponent = (props: keyFeaturesComponentProps) => {
    const { title, img, imgClass = '', list, paragraph = '', flexDirection = 'flex-row' } = props;
    const {t} = useTranslation();

    return (
        <div className="grid gap-16">
            <div className="flex flex-col gap-8 text-center">
                <p className="text-3xl font-semibold text-black-1A1 max-w-3xl m-auto">{t(title || '')}</p>
                <>
                {
                    (paragraph) &&
                    <p className="text-base font-normal text-gray-535 max-w-[48rem] m-auto lg:text-xl">{t(paragraph)}</p>
                }
                </>
            </div>
            <div className={`flex flex-col gap-8 xl:${flexDirection}`}>
                <div
                    className={`relative bg-cover w-full h-[23.125rem] rounded-md bg-gray-DDE ${imgClass} xl:h-full xl:rounded-lg xl:w-[32.5rem]`}
                    style={{ backgroundImage: `url('${img}')`, width: '100%' }}
                ></div>
                <div className="grid xl:w-full">
                    {
                        list?.map((item, index: number) => (
                            <div key={index}
                                className={`grid grid-cols-[auto,1fr] gap-x-5 gap-y-4 py-6 border-gray-E9E ${index > 0 ? 'border-t' : 'border-t-0 pt-0'} xl:grid-cols-[auto,17rem,1fr] xl:gap-5`}
                                >
                                <div>
                                    <p className="text-base font-medium text-gray-414 leading-none border-2 border-gray-E9E rounded-xl p-3">{(index + 1).toString().padStart(2,'0')}</p>
                                </div>
                                <p className="text-lg font-semibold text-black-252 pt-3 xl:text-xl">{t(item.title || '')}</p>
                                <div className={`block xl:hidden`}>{/* Using this div for spacing and alignment bugfix purposes. */}</div>
                                <p className="text-sm font-medium text-gray-535 xl:text-base xl:pt-3">{t(item.paragraph || '')}</p>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    );
};

export default KeyFeaturesComponent;